// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [require('angular-ui-router'), require('ui/web/clientOverview/form').name];

module.exports = angular
  .module('bench.app.mainapp.details.overview.form.ledger', deps)

  .config($stateProvider =>
    $stateProvider.state('bench.details.overview.form.ledger', {
      url: '/ledger/{ledgerId:[0-9]*}',
      views: {
        'modal@': {
          controller($stateParams, Ledger) {
            const { ledgerId } = $stateParams;
            this.ledger = new Ledger(ledgerId);

            return this;
          },
          controllerAs: 'vm',
          template: `\
<bl-client-overview-form ledger="vm.ledger"></bl-client-overview-form>\
`,
        },
      },
    }),
  );
